import { bitcashPrivateRoom } from 'app-view/hooks/use-realtime'
import { P2POffer } from 'app-engine/store/p2p-slice'

export const useRealTimeUncompletedOwnP2POffers = () => {
  const rawOffers = bitcashPrivateRoom.useColyseusState((state) => state.uncompletedOwnP2POffers)
  const publicOffers = rawOffers ? (Object.values(rawOffers.toJSON()) as P2POffer[]) : []
  return publicOffers || []
}
